var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ExportButtons',{on:{"exportCsv":_vm.exportCsv,"exportPdf":_vm.exportPdf,"exportXlsx":_vm.exportXlsx}})
}
var staticRenderFns = []

export { render, staticRenderFns }